import { render, staticRenderFns } from "./AssistantExtras.vue?vue&type=template&id=435dc0e8&scoped=true"
import script from "./AssistantExtras.vue?vue&type=script&lang=js"
export * from "./AssistantExtras.vue?vue&type=script&lang=js"
import style0 from "./AssistantExtras.vue?vue&type=style&index=0&id=435dc0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435dc0e8",
  null
  
)

export default component.exports